import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useContext } from 'react';
import { formStateRefs } from '../../context';
export var useElementsAreReady = function useElementsAreReady() {
  var _useContext = useContext(formStateRefs),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var values = Object.values(state);
  if (values.length <= 0) {
    return false;
  }
  return values.every(function (ref) {
    return ref !== undefined && ref.ready;
  });
};
export var useElementsDidFail = function useElementsDidFail() {
  var _useContext3 = useContext(formStateRefs),
    _useContext4 = _slicedToArray(_useContext3, 1),
    state = _useContext4[0];
  var values = Object.values(state);
  if (values.length <= 0) {
    return false;
  }
  return values.some(function (ref) {
    return ref !== undefined && ref.failed;
  });
};